var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLearning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.001,6.667C26.521,6.2 24.894,6 23.334,6C20.734,6 17.934,6.533 16.001,8C14.067,6.533 11.267,6 8.667,6C6.067,6 3.267,6.533 1.334,8V27.533C1.334,27.867 1.667,28.2 2.001,28.2C2.134,28.2 2.201,28.133 2.334,28.133C4.134,27.267 6.734,26.667 8.667,26.667C11.267,26.667 14.067,27.2 16.001,28.667C17.801,27.533 21.067,26.667 23.334,26.667C25.534,26.667 27.801,27.067 29.667,28.067C29.801,28.133 29.867,28.133 30.001,28.133C30.334,28.133 30.667,27.8 30.667,27.467V8C29.867,7.4 29.001,7 28.001,6.667ZM28.001,24.667C26.534,24.2 24.934,24 23.334,24C21.067,24 17.801,24.867 16.001,26V10.667C17.801,9.533 21.067,8.667 23.334,8.667C24.934,8.667 26.534,8.867 28.001,9.333V24.667Z",
    fill: "#BD7EBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.334,14C24.507,14 25.641,14.12 26.667,14.347V12.32C25.614,12.12 24.481,12 23.334,12C21.067,12 19.014,12.387 17.334,13.107V15.32C18.841,14.467 20.934,14 23.334,14Z",
    fill: "#BD7EBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.334,16.653V18.867C18.841,18.013 20.934,17.547 23.334,17.547C24.507,17.547 25.641,17.667 26.667,17.893V15.867C25.614,15.667 24.481,15.547 23.334,15.547C21.067,15.547 19.014,15.947 17.334,16.653Z",
    fill: "#BD7EBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.334,19.107C21.067,19.107 19.014,19.493 17.334,20.213V22.427C18.841,21.573 20.934,21.107 23.334,21.107C24.507,21.107 25.641,21.227 26.667,21.453V19.427C25.614,19.213 24.481,19.107 23.334,19.107Z",
    fill: "#BD7EBE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning);
export default __webpack_public_path__ + "static/media/learning.db9f047646b041ca1722ee5cee5e8b22.svg";
export { ForwardRef as ReactComponent };